import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import theme from '../../theme';

export const TooltipStyle = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.grey.w600,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    fontSize: 10,
    backgroundColor: theme.palette.grey.w600,
  },
}));

export const SpanTxtStyle = styled('span')({
  color: theme.palette.primary.main,
  // fontWeight: 700
})